import React from 'react';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import format from '../../utils/bindings/format';

import RenderSelectField from '../../utils/renderFields/RenderSelectField';
import { openSelectFormatDialog } from './actions';

let SelectFormatDialog = ({
  openDialogSelectFormat,
  dispatchOpenSelectFormatDialog,
  handleSubmit
}) => (
  <div>
    <Dialog
      open={openDialogSelectFormat}
      onClose={() => dispatchOpenSelectFormatDialog(false)}
      aria-labelledby="form-dialog-title"
    >
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <DialogContentText style={{ marginBottom: 20 }}>
            Sélectionner le format de fichier que vous avez importé
          </DialogContentText>
          <Field
            style={{ width: '100%' }}
            name="format"
            label="Format de votre fichier"
            component={RenderSelectField}
            datas={format}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => dispatchOpenSelectFormatDialog(false)}
            variant="contained"
            color="secondary"
          >
            Annuler
          </Button>
          <Button type="submit" color="primary" variant="contained">
            Valider
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  </div>
);

SelectFormatDialog.propTypes = {
  openDialogSelectFormat: PropTypes.bool.isRequired,
  dispatchOpenSelectFormatDialog: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  openDialogSelectFormat: state.importCommands.openDialogSelectFormat
});

const mapDispatchToProps = dispatch => ({
  dispatchOpenSelectFormatDialog: isOpen =>
    dispatch(openSelectFormatDialog(isOpen))
});

SelectFormatDialog = reduxForm({
  form: 'selectFormatDialog',
  onSubmit: (values, dispatch, props) => {
    dispatch(openSelectFormatDialog(false));
    props.unknowFileType(values.format);
  }
})(SelectFormatDialog);

export default connect(mapStateToProps, mapDispatchToProps)(SelectFormatDialog);
